export type TActivateServiceDialogProps = {
	/** The dialog is open while a jotform is selected. */
	jotformId: number | null;
	onClose: () => void;
};

/**
 * - `EXISTING`: the submission is already linked to an EM, only the subscription can be changed.
 * - `ASSIGN`: the customer said they already have an EM, so one has to be picked before activation.
 * - `CREATE`: a new EM is created from the form and the service is activated for it.
 */
export enum EActivateServiceMode {
	EXISTING = 'existing',
	ASSIGN = 'assign',
	CREATE = 'create',
}

export type TActivateServiceFormValues = {
	fullName: string;
	tinNumber: string;
	contactName: string;
	nominatedEmail: string;
	phone: string;
	registeredCountryId: number | '';
	registeredPostalCode: string;
	regAddressCity: string;
	regStreetNo: string;
	officialSiteUrl: string;
	legalStatus: string;
	paymentHandlingMode: string;
	invoiceFeeTypeId: number | '';
	subscriptionPlanId: number | '';
	existingEmId: number | '';
};
